import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';
import { NEWS_ITEM_IDS, NEWS_VERSION } from '../lib/news';
import { useApp } from '../store';

export function NewsOverlay() {
  const { t } = useTranslation(['news', 'common']);
  const { user, setUser, setNewsOpen } = useApp();
  const [busy, setBusy] = useState(false);

  if (!user) return null;

  async function close() {
    setBusy(true);
    try {
      const res = await api.updateProfile({ newsSeenVersion: NEWS_VERSION });
      setUser(res.user);
    } catch {
      setUser({ ...user!, newsSeenVersion: NEWS_VERSION });
    } finally {
      setBusy(false);
      setNewsOpen(false);
    }
  }

  return (
    <div className="absolute inset-0 z-[45] flex items-center justify-center bg-black/60 p-3 backdrop-blur-[2px] sm:p-6">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="news-title"
        className="relative w-full max-w-lg overflow-hidden rounded-3xl border border-[var(--line)] bg-[var(--bg-panel)] shadow-2xl"
      >
        <div className="border-b border-[var(--line)] px-5 py-4 sm:px-6">
          <p className="text-[10px] uppercase tracking-wider text-[var(--muted)]">{t('news:overlayEyebrow')}</p>
          <h2 id="news-title" className="font-[family-name:var(--font-display)] text-2xl text-[var(--accent)]">
            {t('news:overlayTitle')}
          </h2>
          <p className="mt-1 text-sm text-[var(--muted)]">{t('news:overlayIntro')}</p>
        </div>

        <ul className="max-h-[min(55vh,24rem)] space-y-3 overflow-auto px-5 py-4 sm:px-6">
          {NEWS_ITEM_IDS.map((id) => (
            <li key={id} className="rounded-2xl border border-[var(--line)] bg-[#0b1219]/55 px-4 py-3">
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="text-sm font-semibold text-[var(--ink)]">{t(`news:items.${id}.title`)}</h3>
                <time className="shrink-0 text-[10px] text-[var(--muted)]">{t(`news:items.${id}.date`)}</time>
              </div>
              <p className="mt-1 text-sm leading-relaxed text-[var(--muted)]">{t(`news:items.${id}.body`)}</p>
            </li>
          ))}
        </ul>

        <div className="border-t border-[var(--line)] px-5 py-4 sm:px-6">
          <button
            type="button"
            disabled={busy}
            onClick={() => void close()}
            className="w-full rounded-xl bg-[var(--accent)] px-4 py-3 text-sm font-semibold text-[#1a1408] disabled:opacity-60"
          >
            {busy ? t('common:loadingShort') : t('news:close')}
          </button>
        </div>
      </div>
    </div>
  );
}
